import { Routes } from '@angular/router';

import { authGuard } from './core/auth/auth.guard';
import {
	ForgotPasswordPageComponent,
	LoginPageComponent,
	RegisterPageComponent,
	ResetPasswordPageComponent
} from './pages/auth-pages.component';
import { CheckoutPageComponent, OrdersPageComponent, OtherServicesPageComponent } from './pages/commerce-pages.component';
import { ContactPageComponent, DashboardPageComponent, HomeShellComponent, AboutPageComponent } from './pages/dashboard-pages.component';
import {
	BillingPageComponent,
	GetHelpPageComponent,
	InstitutionsPageComponent,
	MyAccountPageComponent,
	PaymentDetailsPageComponent
} from './pages/profile-pages.component';
import { MyContactsPageComponent } from './pages/contacts-page.component';

export const routes: Routes = [
	{ path: '', pathMatch: 'full', redirectTo: 'login' },
	{ path: 'login', component: LoginPageComponent },
	{ path: 'register', component: RegisterPageComponent },
	{ path: 'forgot-password', component: ForgotPasswordPageComponent },
	{ path: 'reset-password', component: ResetPasswordPageComponent },
	{
		path: '',
		component: HomeShellComponent,
		canActivate: [authGuard],
		children: [
			{ path: 'dashboard', component: DashboardPageComponent },
			{ path: 'about', component: AboutPageComponent },
			{ path: 'contact', component: ContactPageComponent },
			{ path: 'contacts', component: MyContactsPageComponent },
			{ path: 'institutions', component: InstitutionsPageComponent },
			{ path: 'billing', component: BillingPageComponent },
			{ path: 'payment-details', component: PaymentDetailsPageComponent },
			{ path: 'account', component: MyAccountPageComponent },
			{ path: 'help', component: GetHelpPageComponent },
			{ path: 'services', component: OtherServicesPageComponent },
			{ path: 'orders', component: OrdersPageComponent },
			{ path: 'checkout', component: CheckoutPageComponent }
		]
	},
	{ path: '**', redirectTo: 'login' }
];
